import {
  Avatar,
  Box,
  Heading,
  HStack,
  Table,
  TableContainer,
  Tag,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { useData } from "../../../Contexts/DataContext";

const RequirementsTable = ({ requirements, onRequirementClick }) => {
  const { actions = [], developers = [] } = useData();

  const openQuestionsByRequirement = actions
    .filter((a) => a.type === "question" && a.status !== "answered")
    .reduce((acc, question) => {
      acc[question.requirementId] = (acc[question.requirementId] || 0) + 1;
      return acc;
    }, {});

  // Enhance requirements with open questions count
  const enhancedRequirements = requirements.map((req) => ({
    ...req,
    openQuestions: openQuestionsByRequirement[req.id] || 0,
  }));

  return (
    <Box w="100%">
      <Heading size="sm" mb={2} color={"black"}>
        Requirements
      </Heading>
      <TableContainer
        maxH={"50vh"}
        overflowY={"auto"}
        borderColor={"gray.300"}
        borderRadius={"md"}
        borderWidth={1}
      >
        <Table variant="simple" colorScheme="gray">
          <Thead>
            <Tr bg="#1b193e">
              <Th color={"white"}>Requirement</Th>
              <Th color={"white"}>Deliverable</Th>
              <Th color={"white"}>Target Date</Th>
              <Th color={"white"}>Assigned TO</Th>
              <Th color={"white"} textAlign="center">
                Status
              </Th>
              <Th color={"white"} textAlign="center">
                Tasks
              </Th>
              <Th color={"white"} textAlign="center">
                Queries
              </Th>
            </Tr>
          </Thead>
          <Tbody fontSize={"sm"} bg="white">
            {enhancedRequirements.map((req) => {
              const assignedDev = developers.find(
                (dev) => dev.name === req.assignedTo
              );

              // console.log("enhancedRequirements", enhancedRequirements);

              return (
                <Tr
                  key={req.id}
                  _hover={{ bg: "gray.50" }}
                  cursor="pointer"
                  onClick={() => onRequirementClick(req)}
                  color={"black"}
                >
                  <Td>{req.title}</Td>
                  <Td>{req.deliverableName}</Td>
                  <Td>{new Date(req.dueDate).toLocaleDateString()}</Td>
                  <Td>
                    <HStack spacing={2}>
                      <Avatar
                        name={assignedDev?.name}
                        src={assignedDev?.photoURL}
                        size="sm"
                      />
                      <VStack spacing={0} align="start">
                        <Text fontSize="sm">{assignedDev?.name}</Text>
                      </VStack>
                    </HStack>
                  </Td>

                  <Td textAlign="center">
                    <Tag
                      size="sm"
                      colorScheme={
                        req.status === "Completed"
                          ? "green"
                          : req.status === "In Progress"
                          ? "yellow"
                          : "gray"
                      }
                    >
                      {req.status}
                    </Tag>
                  </Td>
                  <Td textAlign="center">
                    {req.tasks.filter((t) => !t.completed).length > 0 ? (
                      <Tag size="sm" colorScheme="red">
                        {req.tasks.filter((t) => !t.completed).length} Open
                      </Tag>
                    ) : (
                      "-"
                    )}
                  </Td>

                  <Td textAlign="center">
                    {req.actions?.length > 0 ? (
                      <Tag size="sm" colorScheme="red">
                        {req.actions?.length} Open
                      </Tag>
                    ) : (
                      "-"
                    )}
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default RequirementsTable;
